import { useEffect } from "react";
import { useBrandLoaderData } from "../../root/rootLoader.ts";
import { useCurrentFullLocale } from "../../../common/utils/locale.ts";
import { updateGTMConsentStatus } from "common/api/monitoring/GA/googleAnalyticsUtils.ts";
import { isNative } from "common/utils/native.ts";

const CookieCat = () => {
  const brand = useBrandLoaderData();
  const locale = useCurrentFullLocale();
  useEffect(() => {
    if (brand.Cookies.notify && !isNative()) {
      window.CookieCat?.init?.(
        {
          app: "dewey",
          theme: brand.Theme.primary,
          locale: locale,
        },
        updateGTMConsentStatus
      );
      window.CookieCat?.onAccept(updateGTMConsentStatus);
    }
  }, [brand, locale]);

  return null;
};

export default CookieCat;
